<script>
import LanguageSelector from '@/components/language-component.vue';

export default {
  components: {
    LanguageSelector,
  },
}
</script>

<template>
    <div class="auth-page-wrapper pt-5">
        <div class="auth-one-bg-position auth-one-bg" id="auth-particles">
            <div class="bg-overlay"></div>
            <div class="shape">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                     viewBox="0 0 1440 120">
                    <path d="M 0,60 L 1440,60"></path>
                </svg>
            </div>
        </div>
        <div class="auth-page-content">
            <BContainer>
                <BRow>
                    <BCol lg="12">
                        <div class="text-center mt-sm-5 mb-4 text-white-50">
                            <div>
                                <router-link to="/" class="d-inline-block auth-logo">
                                    <img src="@/assets/images/logo-light.png" alt="" class="responsive-logo">
                                </router-link>
                            </div>
                          <LanguageSelector />
<!--                            <p class="mt-3 fs-15 fw-medium">{{ $appConfig.title }}</p>-->
                        </div>
                    </BCol>
                </BRow>
                <slot></slot>
            </BContainer>
        </div>
    </div>
</template>

<style>
.responsive-logo {
  max-width: 100%;  /* Makes the image width responsive */
  height: auto;     /* Maintains the aspect ratio */
  /* You can also limit the maximum size of the logo */
  max-height: 60px; /* Example: sets the maximum height */
}
</style>
